import type { SVGProps } from "react";

type IconProps = SVGProps<SVGSVGElement>;

function Icon(props: IconProps) {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" {...props} />
  );
}

export function IconHome(props: IconProps) {
  return <Icon {...props}><path d="M4 10.5 12 4l8 6.5V20H5a1 1 0 0 1-1-1v-8.5Z" /><path d="M9.5 20v-5.5h5V20" /></Icon>;
}

export function IconCard(props: IconProps) {
  return <Icon {...props}><rect x="3" y="5.5" width="18" height="13" rx="2" /><path d="M3 10h18M7 14.5h4" /></Icon>;
}

export function IconDownload(props: IconProps) {
  return <Icon {...props}><path d="M12 4v11m0 0 4.2-4.2M12 15l-4.2-4.2M5 19.5h14" /></Icon>;
}

export function IconLock(props: IconProps) {
  return <Icon {...props}><path d="M7.5 10.5V7.8a4.5 4.5 0 0 1 9 0v2.7" /><rect x="5" y="10.5" width="14" height="9.5" rx="2" /></Icon>;
}

export function IconGlobe(props: IconProps) {
  return <Icon {...props}><circle cx="12" cy="12" r="8.5" /><path d="M3.5 12h17M12 3.5c2.3 2.4 3.4 5.2 3.4 8.5s-1.1 6.1-3.4 8.5c-2.3-2.4-3.4-5.2-3.4-8.5S9.7 5.9 12 3.5Z" /></Icon>;
}

export function IconHelp(props: IconProps) {
  return <Icon {...props}><circle cx="12" cy="12" r="8.5" /><path d="M9.7 9.5a2.3 2.3 0 1 1 3.2 2.1c-.6.3-.9.8-.9 1.4v.5" /><path d="M12 16.6h.01" /></Icon>;
}

export function IconCheck(props: IconProps) {
  return <Icon {...props}><path d="m5.5 12.4 4.1 4 8.9-9" /></Icon>;
}

export function IconExternal(props: IconProps) {
  return <Icon {...props}><path d="M9 6h9v9M18 6 6.5 17.5" /></Icon>;
}

export function IconLogout(props: IconProps) {
  return <Icon {...props}><path d="M10 4.5H6.5a1.5 1.5 0 0 0-1.5 1.5v12a1.5 1.5 0 0 0 1.5 1.5H10" /><path d="M14 8l4 4-4 4M18 12H9.5" /></Icon>;
}

export function IconEye(props: IconProps) {
  return <Icon {...props}><path d="M2.8 12S6.2 5.5 12 5.5 21.2 12 21.2 12 17.8 18.5 12 18.5 2.8 12 2.8 12Z" /><circle cx="12" cy="12" r="2.6" /></Icon>;
}

export function IconEyeOff(props: IconProps) {
  return <Icon {...props}><path d="M4 4l16 16M10.2 6a9 9 0 0 1 1.8-.2c5.8 0 9.2 6.2 9.2 6.2a16 16 0 0 1-2.6 3.3M6.6 7.5A15.6 15.6 0 0 0 2.8 12s3.4 6.5 9.2 6.5a8.6 8.6 0 0 0 4-1M10.2 10.3a2.6 2.6 0 0 0 3.5 3.5" /></Icon>;
}

export function IconCompass(props: IconProps) {
  return <Icon {...props}><circle cx="12" cy="12" r="8.5" /><path d="m15.4 8.6-2 4.8-4.8 2 2-4.8 4.8-2Z" /></Icon>;
}

export function IconBuilding(props: IconProps) {
  return <Icon {...props}><path d="M4 20V9.5L12 4l8 5.5V20" /><path d="M9.5 20v-5h5v5M3 20h18" /></Icon>;
}

export function IconBank(props: IconProps) {
  return <Icon {...props}><path d="M3.5 9 12 4.5 20.5 9M5 9.5v8M9.7 9.5v8M14.3 9.5v8M19 9.5v8M3.5 19.5h17" /></Icon>;
}

export function IconBriefcase(props: IconProps) {
  return <Icon {...props}><rect x="3.5" y="7.5" width="17" height="12" rx="2" /><path d="M9 7.5V6a1.5 1.5 0 0 1 1.5-1.5h3A1.5 1.5 0 0 1 15 6v1.5M3.5 12.5h17" /></Icon>;
}
